import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class AppValidators {
  public static dateIsLaterOrEqualThan(today: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: Date = control.value;
      const dateInvalid = value && value.valueOf() < today.valueOf();
      return dateInvalid ? { dateIsLaterThan: true } : null;
    };
  }
}
